import { ReactComponent as Success } from '@basqet-dashboard/common/assets/icons/success.svg';
import { Button } from '@basqet-dashboard/common/components';
import PropTypes from 'prop-types';
import React from 'react';

const SignupComplete = ({ userEmail }) => {
  return (
    <div className="auth__success">
      <div className="auth__success__body">
        <Success role="img" />
        <h3>Account created successfully</h3>
        <p>
          Click the link that was sent to your email
          <br /> <b>{userEmail}</b> <br />
          to verify your account{' '}
        </p>
      </div>
      <Button isFull type="button" onClick={() => window.location.replace('/login')}>
        Back to Login page
      </Button>
    </div>
  );
};

SignupComplete.propTypes = {
  userEmail: PropTypes.string.isRequired
};

export { SignupComplete };
